import { useState } from "react";
import "./style.scss";
import OkIcon from "./img/ok.svg";
import ErrorIcon from "./img/error.svg";
import InputError from "../InputError/InputError";
import NiceModal from "@ebay/nice-modal-react";
const inputClass = {
  base: "input",
  error: "error",
  disabled: "disabled",
};

export default function Input({
  label,
  disabled,
  required,
  placeholder,
  name,
  icon,
  register,
  errors = {},
  type = "text",
  touched = false,
  validationRules,
  modal,
  disableMessage = false,
  onModalClose,
  onClickCallback,
  ...res
}) {
  const showIsValid = !errors?.message && touched;
  const errorMesage = errors?.message;
  const [showPass, setShowPass] = useState(false);
  // const handleInputClick = () => {
  //   if (modal) {
  //     NiceModal.show(modal, {onModalClose: onModalClose});
  //   }
  // };
  const handleIconClick = (e) => {
    e.stopPropagation();
    setShowPass((prev) => !prev);
  };

  return (
    <div className="input-wrapper">
      <div className="top">
        <label className="label" htmlFor={name}>
          {label}
        </label>

        {showIsValid && !disableMessage && (
          <div className="input-icon">
            <img src={OkIcon} alt="ok-icon" />
          </div>
        )}

        {errorMesage && !disableMessage && (
          <div className="input-icon">
            <img src={ErrorIcon} alt="error-icon" />
          </div>
        )}
      </div>
      <div className="input-container" onClick={onClickCallback}>
        <input
          type={showPass ? "text" : type}
          name={name}
          disabled={disabled}
          placeholder={placeholder}
          className={`${inputClass.base}
          ${showIsValid && !disableMessage ? "valid" : ""}
          ${errorMesage && !disableMessage ? inputClass.error : ""}
          ${disabled ? inputClass.disabled : ""}`}
          {...register(`${name}`, {
            ...validationRules,
          })}
          {...res}
        />
        {icon && <img className="icon" src={icon} alt="placeholder" />}
        {type === "password" &&
          (showPass ? (
            <svg
              className="show-password-icon"
              onClick={handleIconClick}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.9955 3.19505C4.30199 2.91642 4.77633 2.93901 5.05496 3.2455L20.055 19.7455C20.3336 20.052 20.311 20.5263 20.0045 20.805C19.698 21.0836 19.2237 21.061 18.9451 20.7545L3.94505 4.25451C3.66642 3.94802 3.68901 3.47368 3.9955 3.19505Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.0332 8.72016C10.3118 9.02668 10.2892 9.50101 9.98267 9.77961C9.5346 10.1869 9.22025 10.7202 9.08095 11.3095C8.94166 11.8987 8.98393 12.5163 9.20222 13.0811C9.4205 13.6459 9.80459 14.1314 10.304 14.4738C10.8034 14.8163 11.3947 14.9995 12.0002 14.9996L12.0029 14.9996C12.7477 15.0024 13.4662 14.7247 14.0153 14.2216C14.3208 13.9418 14.7952 13.9626 15.075 14.268C15.3548 14.5734 15.334 15.0478 15.0286 15.3276C14.2017 16.0851 13.1199 16.5035 11.9986 16.4996C11.9981 16.4996 11.9977 16.4996 11.9972 16.4996L12.0001 15.7496L12 16.4996C11.9995 16.4996 11.9991 16.4996 11.9986 16.4996C11.0908 16.4992 10.2044 16.2243 9.45571 15.711C8.70664 15.1973 8.13051 14.4691 7.80308 13.6219C7.47565 12.7747 7.41224 11.8483 7.62119 10.9644C7.83013 10.0805 8.30165 9.28051 8.97376 8.66961C9.28028 8.39101 9.75461 8.41364 10.0332 8.72016Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.60689 6.09279C7.79358 6.46255 7.64518 6.91364 7.27542 7.10033C5.49276 8.0004 4.21533 9.30424 3.37972 10.3954C2.96317 10.9394 2.6606 11.4251 2.46368 11.7716C2.41552 11.8563 2.37377 11.9326 2.33828 11.9992C2.42652 12.1645 2.5533 12.3891 2.7205 12.6547C3.09628 13.2515 3.67199 14.0485 4.46772 14.8442C6.05485 16.4314 8.49932 17.9996 11.9999 17.9996H12.006C13.6442 18.0129 15.2619 17.6355 16.725 16.8985C17.0949 16.7122 17.5459 16.861 17.7322 17.2309C17.9186 17.6009 17.7697 18.0518 17.3998 18.2381C15.7246 19.082 13.8724 19.5144 11.9968 19.4996C7.99902 19.4987 5.19447 17.6923 3.40706 15.9049C2.51529 15.0131 1.87224 14.1227 1.45115 13.4539C1.24024 13.1189 1.08394 12.8378 0.97907 12.6376C0.926609 12.5375 0.886936 12.4574 0.859661 12.4007C0.84602 12.3724 0.835472 12.3499 0.827969 12.3337L0.818988 12.3141L0.816196 12.3079L0.815223 12.3057C0.815062 12.3054 0.814531 12.3042 1.49989 11.9996C0.814239 11.6956 0.814347 11.6954 0.814461 11.6951L0.815351 11.6931L0.817067 11.6893L0.822322 11.6777L0.840173 11.6392C0.855355 11.6069 0.877141 11.5615 0.905684 11.5044C0.962752 11.3901 1.04695 11.2286 1.15954 11.0305C1.38449 10.6346 1.72411 10.0903 2.18881 9.48343C3.1157 8.27304 4.55702 6.7925 6.59936 5.76132C6.96911 5.57463 7.4202 5.72304 7.60689 6.09279ZM1.49989 11.9996L0.814461 11.6951C0.728559 11.8889 0.728444 12.1105 0.814531 12.3042L1.49989 11.9996Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.93538 4.66969C10.6178 4.55545 11.3086 4.4987 12.0005 4.50002C15.9996 4.50024 18.8049 6.30693 20.5927 8.09469C21.4844 8.98646 22.1275 9.87693 22.5486 10.5457C22.7595 10.8807 22.9158 11.1618 23.0206 11.362C23.0731 11.4621 23.1128 11.5422 23.1401 11.5989C23.1537 11.6272 23.1642 11.6497 23.1717 11.6659L23.1807 11.6855L23.1835 11.6917L23.1845 11.6939C23.1847 11.6942 23.1852 11.6954 22.4998 12C21.8145 11.6954 21.8145 11.6953 21.8146 11.6951L21.8089 11.7075C21.8036 11.7189 21.7948 11.7377 21.7824 11.7632C21.7577 11.8142 21.7188 11.892 21.6653 11.9925C21.6639 11.995 21.6626 11.9975 21.6612 12C21.573 11.8348 21.4463 11.6103 21.2792 11.3449C20.9034 10.7481 20.3277 9.95108 19.532 9.15535C17.9449 7.56822 15.5004 6.00002 11.9998 6.00002H11.9983C11.3901 5.99882 10.7829 6.04869 10.183 6.14911C9.77449 6.21749 9.38788 5.94175 9.31949 5.53322C9.25111 5.12469 9.52685 4.73808 9.93538 4.66969ZM22.4998 12L23.1852 12.3046C23.2714 12.1107 23.2714 11.8893 23.1852 11.6954L22.4998 12ZM21.6612 12C21.5541 12.2008 21.3903 12.4885 21.1666 12.8306C20.7126 13.525 20.0176 14.434 19.0561 15.2942C18.7473 15.5703 18.7209 16.0444 18.9971 16.3532C19.2732 16.6619 19.7474 16.6883 20.0561 16.4121C21.1383 15.4441 21.9152 14.4266 22.4221 13.6515C22.676 13.2631 22.8637 12.9333 22.9893 12.6975C23.0521 12.5796 23.0995 12.4849 23.1319 12.418C23.1482 12.3846 23.1607 12.358 23.1695 12.339L23.1801 12.316L23.1833 12.3088L23.1844 12.3064L23.1852 12.3046C23.1853 12.3044 23.1852 12.3046 22.4998 12C21.8145 12.3046 21.8146 12.3049 21.8147 12.3052L21.8102 12.2954C21.8059 12.2861 21.7987 12.2707 21.7886 12.2496C21.7682 12.2074 21.7361 12.1424 21.6919 12.058C21.6823 12.0396 21.672 12.0202 21.6612 12Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.9664 8.17594C12.0435 7.76897 12.4359 7.50157 12.8429 7.57868C13.8003 7.76007 14.6727 8.24795 15.3284 8.96868C15.9842 9.68941 16.3877 10.6039 16.4782 11.5741C16.5166 11.9865 16.2134 12.352 15.801 12.3905C15.3886 12.4289 15.0231 12.1257 14.9846 11.7133C14.9244 11.0672 14.6557 10.4581 14.2189 9.97816C13.7822 9.49817 13.2012 9.17326 12.5636 9.05246C12.1567 8.97534 11.8893 8.58292 11.9664 8.17594Z"
                fill="white"
              />
            </svg>
          ) : (
            <svg
              className="show-password-icon"
              onClick={handleIconClick}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12 5.25C4.5 5.25 1.5 12 1.5 12C1.5 12 4.5 18.75 12 18.75C19.5 18.75 22.5 12 22.5 12C22.5 12 19.5 5.25 12 5.25Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ))}
      </div>

      {errorMesage && !disableMessage && (
        <InputError errorMessage={errorMesage} />
      )}
    </div>
  );
}
